/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BigBoardAdvancedMetricsDtoListResult } from '../../models/big-board-advanced-metrics-dto-list-result';

export interface ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Params {
  CompetitionId?: number;
  WatchlistIds?: Array<number>;
  PlayerIds?: Array<number>;
  ClassYears?: Array<string>;
  Positions?: Array<string>;
  OverridenPositions?: Array<string>;
  ConferenceIds?: Array<number>;
  TeamIds?: Array<number>;
  MetricType?: string;
  Limit?: number;
  Offset?: number;
  OrderByColumn?: string;
  OrderDirection?: string;
}

export function apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>> {
  const rb = new RequestBuilder(rootUrl, apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse.PATH, 'get');
  if (params) {
    rb.query('CompetitionId', params.CompetitionId, {});
    rb.query('WatchlistIds', params.WatchlistIds, {});
    rb.query('PlayerIds', params.PlayerIds, {});
    rb.query('ClassYears', params.ClassYears, {});
    rb.query('Positions', params.Positions, {});
    rb.query('OverridenPositions', params.OverridenPositions, {});
    rb.query('ConferenceIds', params.ConferenceIds, {});
    rb.query('TeamIds', params.TeamIds, {});
    rb.query('MetricType', params.MetricType, {});
    rb.query('Limit', params.Limit, {});
    rb.query('Offset', params.Offset, {});
    rb.query('OrderByColumn', params.OrderByColumn, {});
    rb.query('OrderDirection', params.OrderDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BigBoardAdvancedMetricsDtoListResult>;
    })
  );
}

apiBigBoardAdvanceMetricsGet$JsonOdataStreamingFalse.PATH = '/api/big-board/advance-metrics';
